import { Component, computed, inject, signal } from '@angular/core';

// Components
import { NavbarComponent } from "../../../template/components/navbar/navbar.component";

// NG-Bootstrap
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

// Services
import { FaqService } from '../../services/faq.service';

// Pipes
import { SafeHtmlPipe } from "../../../shared/pipes/safe-html.pipe";


@Component({
  selector: 'app-faq',
  imports: [NgbAccordionModule, NavbarComponent, SafeHtmlPipe],
  templateUrl: './faq.component.html'
})
export class FaqComponent {
  private readonly faqSrv = inject(FaqService);

  navList: { label: string, routePath: string }[] = [{ label: 'Supporto', routePath: '/faq' }];

  searchValue = signal('');

  readonly filteredFaqList = computed(() => {
    const search = this.searchValue().toLowerCase();
    return this.faqSrv.faqList().filter(faq =>
      faq.questionMarkdown?.toLowerCase().includes(search)
    );
  });
}
